import styled from 'styled-components';

export const AIAssistantContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 12px;
  background: #f6f6f6;
  overflow: hidden;
  border-radius: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: inline-flex;
`;

export const AIStatusBadge = styled.div`
  align-self: stretch;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  background: #e6f7ff;
  border-radius: 50px;
  outline: 1px #ff0000 solid;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: inline-flex;
`;

export const AIContentContainer = styled.div`
  flex: 1 1 0;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  display: flex;
`;

export const AIIconContainer = styled.div`
  width: 18px;
  height: 18px;
  position: relative;
  overflow: hidden;
`;

export const AIHeaderContainer = styled.div`
  flex: 1 1 0;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: flex;
`;

export const AITitleText = styled.span`
  color: #018ccc;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 800;
  line-height: 16px;
  letter-spacing: 0.5px;
  word-wrap: break-word;
`;

export const AIDescriptionContainer = styled.div`
  align-self: stretch;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: inline-flex;
`;

export const AIDescriptionText = styled.span`
  color: #545454;
  font-size: 11px;
  font-family: Poppins;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.5px;
  word-wrap: break-word;
`;

export const AIStatusRow = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: inline-flex;
`;

export const AIStatusLabel = styled.span`
  color: #545454;
  font-size: 12px;
  font-family: Poppins;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.5px;
  word-wrap: break-word;
`;
